import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Pagination,
  PaginationItem,
  Avatar,
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
  useTheme,
  IconButton,
  Collapse,
  Grid
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import Page from 'src/components/Page';
import { TableNoData } from '../NoData';
import BookingDetailsCard from '../BookingDetailsCard';
import ShipmentDetailsCard from '../ShipmentDetailsCard';
import ShiperProfileComponent from '../ShiperProfileComponent';
import BookerProfileComponent from '../BookerProfileComponent';

export default function SentBookingRequest() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check for mobile screen
  const userData = JSON.parse(localStorage.getItem('user'));

  const [bookingRequest, setBookingRequest] = useState([]);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [shipmentDetails, setShipmentDetails] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [openBookingCard, setOpenBookingCard] = useState(false);
  const [openShipmentCard, setOpenShipmentCard] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);

  const [loading, setloading] = useState(false);
  const [loadingBooking, setloadingBooking] = useState(false);
  const [loadingShipment, setloadingShipment] = useState(false);
  const [loadingProfile, setloadingProfile] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);
  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectLoad, setSelectLoad] = useState('');

  useEffect(() => {
    if (search.length == 0) {
      bookingRequest.length = 0;
      getSentBookingRequest(page);
    }
  }, [search]);

  useEffect(() => {
    getSentBookingRequest(page);
  }, [page]);

  function getSentBookingRequest(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    queryParams.append('request_type', 'sent');
    queryParams.append('request_by', 'booker');

    fetch(`${api.get_invitation}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setBookingRequest(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setBookingRequest([]);
          setpagesCount(0);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  function GetBookingById(booking_id) {
    setloadingBooking(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('truck_id', booking_id);

    fetch(`${api.get_truck_by_id}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setBookingDetails(result.data);
          setloadingBooking(false);
          setOpenBookingCard(true);
        } else {
          setloadingBooking(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingBooking(false);
      });
  }

  function GetShipmentById(shipment_id) {
    setloadingShipment(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('shipment_id', shipment_id);

    fetch(`${api.get_shipment_by_id}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setShipmentDetails(result.data);
          setloadingShipment(false);
          setOpenShipmentCard(true);
        } else {
          setloadingShipment(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingShipment(false);
      });
  }

  function getRequestTruckProfile(company_id) {
    setloadingProfile(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('user_id', company_id);
    queryParams.append('profile_type', 'Booker');

    fetch(`${api.get_profiles}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setProfileData(result.data[0]);
          setloadingProfile(false);
          setOpenProfileModal(true);
        } else {
          setloadingProfile(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingProfile(false);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handlePageChange = (event, value) => {
    bookingRequest.length = 0;
    setPage(value);
    getSentBookingRequest(value);
  };

  const handleStatusChange = (index, newStatus) => {
    // setRequestList((prevList) => {
    //   const updatedList = [...prevList];
    //   const customer = updatedList[index];
    //   // Update status in the local state
    //   customer.status = newStatus;
    //   // Call API to update status on the server
    //   handleChangeStatus(customer.id, newStatus);
    //   return updatedList;
    // });
  };

  const handleCloseBookingCard = (e) => {
    setOpenBookingCard(false);
    setBookingDetails(null);
  };

  const handleCloseShipmentCard = (e) => {
    setOpenShipmentCard(false);
    setShipmentDetails(null);
  };

  const handleCloseProfileModal = () => {
    setOpenProfileModal(false);
    setProfileData(null);
  };

  const handleRowClick = (rowIndex) => {
    setExpandedRow((prevIndex) => (prevIndex === rowIndex ? null : rowIndex));
  };

  return (
    <Page title={`Invitations  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container sx={{ padding: '0px' }}>
        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Requests'}
              onEnter={() => {
                setsearchLoading(true);
                bookingRequest.length = 0;
                getSentBookingRequest();
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getSentBookingRequest(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 120 }}>
                  COMPANY
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 130 }}>
                  REQUEST DATE
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                  BOOKING
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                  SHIPMENT
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                  PROFILE
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 110 }}>
                  MESSAGE
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    width: 110
                  }}
                >
                  STATUS
                </TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {bookingRequest.map((user, index) => {
                  return (
                    <>
                      <TableRow
                        key={index}
                        onClick={() => {
                          handleRowClick(index);
                          setSelectLoad(user);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <TableCell scope="row" padding="normal">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Avatar alt={user?.company?.company} src={user?.company?.avatar} />
                            <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                              <Typography variant="subtitle2" flexWrap={'wrap'}>
                                {user?.company?.company || 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 110 }}>
                            {moment(user?.request_date).format('MM/DD/YYYY')}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <IconButton
                            disabled={!user?.booking_id}
                            onClick={(e) => {
                              GetBookingById(user?.booking_id);
                            }}
                            style={{ fontSize: 22, color: '#010f58' }}
                          >
                            {loadingBooking ? (
                              <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                            ) : (
                              <Iconify
                                style={{ color: !user?.booking_id ? '#999999' : '#010f58' }}
                                icon="fa6-solid:truck-fast"
                              />
                            )}
                          </IconButton>
                        </TableCell>

                        <TableCell>
                          <IconButton
                            disabled={!user?.shipment_id}
                            onClick={(e) => {
                              GetShipmentById(user?.shipment_id);
                            }}
                            style={{ fontSize: 26, color: '#010f58' }}
                          >
                            {loadingShipment ? (
                              <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                            ) : (
                              <Iconify
                                style={{ color: !user?.shipment_id ? '#999999' : '#010f58' }}
                                icon="fontisto:ship"
                              />
                            )}
                          </IconButton>
                        </TableCell>

                        <TableCell>
                          <IconButton
                            onClick={(e) => {
                              getRequestTruckProfile(user?.company?.id);
                            }}
                            style={{ fontSize: 22, color: '#010f58' }}
                          >
                            {loadingProfile ? (
                              <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                            ) : (
                              <Iconify icon="icomoon-free:profile" />
                            )}
                          </IconButton>
                        </TableCell>

                        <TableCell>
                          <IconButton
                            component={RouterLink}
                            to={`/dashboard/invitations/messages`}
                            state={{ invitation_id: user?.id }}
                            style={{ fontSize: 28, color: '#010f58' }}
                          >
                            <Iconify icon="duo-icons:message-3" />
                          </IconButton>
                        </TableCell>

                        <TableCell align="center">
                          <Typography
                            className={
                              (user?.truck?.status.toLowerCase() == 'posted' && 'status-green') ||
                              (user?.truck?.status.toLowerCase() == 'completed' &&
                                'status-green') ||
                              (user?.truck?.status.toLowerCase() == 'booked' && 'status-booked') ||
                              (user?.truck?.status.toLowerCase() == 'unposted' && 'status-blue') ||
                              (user?.truck?.status.toLowerCase() == 'pending' && 'status-blue') ||
                              (user?.truck?.status.toLowerCase() == 'paid' && 'status-blue') ||
                              (user?.truck?.status.toLowerCase() == 'partially fulfilled' &&
                                'status-blue') ||
                              (user?.truck?.status.toLowerCase() == 'expired' && 'status-red') ||
                              (user?.truck?.status.toLowerCase() == 'deleted' && 'status-red')
                            }
                          >
                            {user?.truck?.status || 'N/A'}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      <TableRow style={{ display: expandedRow !== index && 'none' }}>
                        <TableCell
                          style={{ backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 }}
                          colSpan={11}
                        >
                          <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                            <Grid container spacing={2} mb={2} style={{ height: '30%' }}>
                              {/* Trip Section */}
                              <Grid item xs={12} sm={6} style={{ position: 'relative' }}>
                                {/* Header */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    TRIP
                                  </p>
                                </Box>

                                {/* Content Section */}
                                <Box
                                  style={{
                                    marginTop: 2,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    position: 'relative'
                                  }}
                                >
                                  {/* Row 1 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:dot-square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.truck?.location_origin}
                                    </Typography>
                                  </Box>

                                  {/* Row 2 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.truck?.location_destination}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Vertical Icons */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    position: 'absolute',
                                    top: 70,
                                    left: 26.5
                                  }}
                                >
                                  {Array(4)
                                    .fill(null)
                                    .map((_, idx) => (
                                      <Iconify
                                        key={idx}
                                        icon="pepicons-pop:line-y"
                                        style={{
                                          fontSize: 7, // Fixed line size
                                          color: '#010f58',
                                          marginBottom: 3
                                        }}
                                      />
                                    ))}
                                  <Iconify
                                    icon="ion:arrow-down-outline"
                                    style={{
                                      fontSize: 11, // Fixed arrow size
                                      color: '#010f58'
                                    }}
                                  />
                                </Box>
                              </Grid>

                              {/* Details Section */}
                              <Grid item xs={12} sm={6}>
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    DETAILS
                                  </p>
                                </Box>

                                <Box
                                  style={{
                                    paddingLeft: 10,
                                    paddingRight: 10
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Equipment Type :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.truck?.equipment_type || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Length :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {`${selectLoad?.truck?.length_ft}/${selectLoad?.truck?.length_unit}` ||
                                        '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Weight :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {`${selectLoad?.truck?.weight_lbs}/${selectLoad?.truck?.weight_unit}` ||
                                        '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Rate :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.truck?.rate || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Equipment Name :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.truck?.equipment_name || '-'}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Reference ID :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.truck?.reference_id || '-'}
                                    </Typography>
                                  </Box>

                                  {/* <Box
                                                                             sx={{
                                                                               width: '100%',
                                                                               display: 'flex',
                                                                               justifyContent: 'center',
                                                                               alignItems: 'flex-start',
                                                                               marginBottom: 0.5
                                                                             }}
                                                                           >
                                                                             <Typography style={{ color: 'grey', fontSize: 12 }}>
                                                                               DHO | DHD :
                                                                             </Typography>
                                                                             <Typography
                                                                               style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                                                             >
                                                                               {selectLoad?.truck?.dhO && selectLoad?.truck?.dhd
                                                                                 ? `${selectLoad?.truck?.dhO} | ${selectLoad?.truck?.dhd}`
                                                                                 : '-'}
                                                                             </Typography>
                                                                           </Box> */}

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        width: '17%',
                                        color: 'grey',
                                        fontSize: 12
                                      }}
                                    >
                                      Comment :
                                    </Typography>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        marginLeft: 20,
                                        flex: 1
                                      }}
                                    >
                                      {selectLoad?.truck?.comments || '-'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {bookingRequest.length == 0 && !loading && <TableNoData colSpan={10} />}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && bookingRequest.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <BookingDetailsCard
          open={openBookingCard}
          onClose={handleCloseBookingCard}
          booking={bookingDetails}
        />

        <ShipmentDetailsCard
          open={openShipmentCard}
          onClose={handleCloseShipmentCard}
          shipment={shipmentDetails}
        />

        <BookerProfileComponent
          open={openProfileModal}
          onClose={handleCloseProfileModal}
          companyData={profileData}
        />

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
